// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-xsxxcjcx-tyXsxxcjcx-index-main_right_content-pY8hB","table":"components-tjcx-xsxxcjcx-tyXsxxcjcx-index-table-2D5Oc"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/xsxxcjcx/tyXsxxcjcx/index.css
// module id = 2323
// module chunks = 0